
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { DownloadIcon, ShareIcon } from '@heroicons/react/outline';
import { ImgComparisonSlider } from '@img-comparison-slider/react';
import { useSearchParams } from 'next/navigation';
import useLocale from 'next-translate/useTranslation';
import React, { useState } from 'react';
import uuidv4 from '@/lib/uuid';
import Button from '@/components/buttons/Button';
import CallToAction from '@/components/CallToAction';
import Features2 from '@/components/Features2';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import ButtonLink from '@/components/links/ButtonLink';
import Seo from '@/components/Seo';
import axiosInstance from '@/utils/httpClient';
import { createClient } from '@/utils/supabase/component';
const UpscaleImage = () => {
    const supabaseClient = createClient();
    const { t } = useLocale('magic-upscaler');
    const [uploadedFiles, setUploadedFiles] = useState<any>({});
    const [isFileLoading, setIsFileLoading] = useState(false);
    const [newBeforeImage, setNewBeforeImage] = useState('');
    const [newAfterImage, setNewAfterImage] = useState('');
    const searchParams = useSearchParams();
    const beforeImage = searchParams?.get('before') || '/images/bird_before.jpeg';
    const afterImage = searchParams?.get('after') || '/images/bird_after.jpeg';
    //beforeImage = 'https://api.easy-peasy.ai/storage/v1/object/public/uploads/upscale/50c2354d-d5f7-45e5-a011-be05e613ffbb.webp',
    //afterImage = 'https://replicate.delivery/pbxt/YFu7t4msQhKRKJFXNYwVLQs7BWyOyHcFEi96VqqR6CwUPNoE/1337-61f88eb4-e398-11ee-ac23-2e4d2d571075.png',
    const handleFileUpload = async (fieldName: string) => {
        // upload to Supabase
        setIsFileLoading(true);
        const file = (document.getElementById(fieldName) as any).files[0];
        const fileExt = file.name.split('.').pop();
        const fileName = `${uuidv4()}.${fileExt}`;
        const filePath = `upscale/${fileName}`;
        // Add validation for image width
        const image = new Image();
        image.src = URL.createObjectURL(file);
        const isImageLoaded = new Promise((resolve, reject) => {
            image.onload = () => resolve(true);
            image.onerror = () => reject(new Error('Image loading failed'));
        });
        try {
            await isImageLoaded;
            if (image.width > 1500) {
                throw new Error('Image width is more than 1500 pixels. Please upload an image with a width of less than 1500 pixels.');
            }
        }
        catch (error) {
            alert(error);
            setIsFileLoading(false);
            return;
        }
        const { data, error } = await supabaseClient.storage
            .from('uploads')
            .upload(filePath, file);
        if (error) {
            console.log(error);
            return;
        }
        const fileData = await supabaseClient.storage
            .from('uploads')
            .getPublicUrl(filePath);
        // send to API
        try {
            const response = await axiosInstance.post('/api/upscale-image', {
                image: fileData.data.publicUrl,
            });
            setNewBeforeImage(fileData.data.publicUrl as string);
            setNewAfterImage(response.data.data as string);
            // update query params in URL
            const currentUrl = window.location.href;
            const url = new URL(currentUrl);
            url.searchParams.set('before', fileData.data.publicUrl as string);
            url.searchParams.set('after', response.data.data as string);
            window.history.pushState({}, '', url.toString());
            setIsFileLoading(false);
        }
        catch (error) {
            alert('Something went wrong.');
            console.log(error);
            setIsFileLoading(false);
        }
    };
    return (<main className='relative bg-gray-100 dark:bg-slate-900'>
      <Seo templateTitle={t('Free AI Image Upscaler')} description={t('Use our free tool to upscale your images and improve the quality of your photos.')} image={afterImage as string}/>
      <div className='relative overflow-hidden bg-white dark:bg-slate-900'>
        <div className='mx-auto'>
          <LandingPageNavigation />
          <div className='relative z-10 bg-white pb-8 dark:bg-slate-900  lg:w-full'>
            <div className='relative  bg-white dark:bg-slate-900'>
              <div className='mx-auto'>
                <main className='mx-auto mt-16 max-w-7xl px-4 sm:mt-24 sm:px-6 lg:mt-32'>
                  <div className=''>
                    <div className='relative z-30 text-center md:mx-auto'>
                      <h1 className='mt-1 block bg-gradient-to-r from-indigo-400 to-pink-600 bg-clip-text pb-3 text-4xl font-bold tracking-tight text-transparent sm:text-5xl '>
                        {t('Free AI Image Upscaler')}
                      </h1>
                      <p className='text-base text-gray-500  sm:text-xl lg:text-lg xl:text-xl'>
                        {t('Use our free tool to upscale your images and improve the quality of your photos.')}
                      </p>
                    </div>
                  </div>

                  <div className='mt-10 flex flex-col items-center'>
                    {uploadedFiles['upscale_image'] && (<div className='mb-5 mt-5'>
                        <div className='mb-4 flex items-center pr-1 last:mb-0'>
                          <div className='flex items-center'>
                            <span className='text-base'>
                              <img height={150} className='max-h-64 rounded-lg' src={URL.createObjectURL((document.getElementById('upscale_image') as any).files[0])}/>
                            </span>
                          </div>
                        </div>
                      </div>)}
                    {/* <label className='text-blue border-blue mt-1 flex w-64 cursor-pointer items-center rounded-lg border bg-white px-4 py-2 tracking-wide shadow-lg hover:border-primary-500 hover:text-primary-500 dark:bg-slate-800'>
          {isFileLoading ? (
            <Spinner className='mr-4 h-8 w-8 animate-spin text-primary-500' />
          ) : (
            <UploadIcon className='mr-4 h-8 w-8 text-primary-500' />
          )}
          {isFileLoading ? (
            <span className='mt-2 text-center'>
              {t('Uploading...')}
              <br />
              <span className='text-xs text-gray-500'>
                Can take about 30-40 seconds
              </span>
            </span>
          ) : (
            <span className='mt-2 flex flex-col text-center'>
              {t('Click to upload a file')}
              <span className=' text-xs text-gray-500'>
                jpg, png, webp
              </span>
            </span>
          )}

          <input
            type='file'
            className='hidden'
            id='upscale_image'
            accept='image/*'
            onChange={() => handleFileUpload('upscale_image')}
          />
        </label> */}
                    <ButtonLink href='/magic-upscaler' variant='primary'>
                      {t('Login to Upscale')}
                    </ButtonLink>
                  </div>
                  {newBeforeImage && (<div className='mt-5 flex justify-center space-x-4'>
                      <Button variant='outline' onClick={() => {
                const currentUrl = window.location.href;
                const shareUrl = `${currentUrl}`;
                navigator.clipboard.writeText(shareUrl);
                alert('URL copied to clipboard');
            }}>
                        <ShareIcon className='mr-2 h-6 w-6'/>
                        {t('Share')}
                      </Button>
                      <Button variant='outline' onClick={() => {
                const newImage = newAfterImage;
                const link = document.createElement('a');
                link.href = newImage;
                link.target = '_blank';
                link.download = 'upscaled_image.png';
                link.click();
            }}>
                        <DownloadIcon className='mr-2 h-6 w-6'/>
                        {t('Download')}
                      </Button>
                    </div>)}
                  <div className=' mt-12 flex justify-center'>
                    {newBeforeImage && newAfterImage ? (<ImgComparisonSlider className='w-3/4'>
                        <img slot='first' src={newBeforeImage} width='100%'/>
                        <img slot='second' src={newAfterImage} width='100%'/>
                      </ImgComparisonSlider>) : (<ImgComparisonSlider className='w-3/4'>
                        <img slot='first' src={beforeImage as string} width='100%'/>
                        <img slot='second' src={afterImage as string} width='100%'/>
                      </ImgComparisonSlider>)}
                  </div>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=' bg-white px-5 py-20 dark:bg-slate-900'>
        <div className='mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8'>
          <h2 className='text-3xl font-semibold text-indigo-600'>
            {t('Other Free Tools')}
          </h2>
          <Features2 showAll={false} isFree={true}/>
        </div>
      </div>

      <CallToAction />
      <Footer />
    </main>);
};
export default UpscaleImage;

    async function __Next_Translate__getStaticProps__1a0cbfb65eb__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/free-tools/upscale-image',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0cbfb65eb__ as getStaticProps }
  